import { FC } from 'react'
import { Flex } from '@radix-ui/themes'
import styles from './neon.module.scss'

interface Props {
  icon: React.ReactNode
  title: string
  action?: React.ReactNode
  uppercase?: boolean
}
export const NeonSectionHeading: FC<Props> = ({
  icon,
  title,
  action,
  uppercase = false
}) => {
  return (
    <Flex
      align={'center'}
      justify={'between'}
      gap={'2'}
      width={'100%'}
    >
      <Flex
        align={'center'}
        gap={'2'}
      >
        <span className={styles.headingIcon}>{icon}</span>

        <span
          className={styles.headingTitle}
          data-uppercase={uppercase}
        >
          {title}
        </span>
      </Flex>

      {action ?? null}
    </Flex>
  )
}
